/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import notifications from "../../assets/json/notifications";
import message from "../../assets/json/message";
import ProfileModelPopup from "../../components/modelpopup/ProfileModelPopup";
import moment from "moment";
import { Modal } from "bootstrap";
import {
  Applogo,
  Avatar_02,
  Avatar_01,
  headerlogo,
  lnEnglish,
  lnFrench,
  lnGerman,
  lnSpanish,
} from "../../Routes/ImagePath";
import { FaRegBell, FaRegComment } from "react-icons/fa";
import ProfileMenu from "./ProfileMenu";

const getSafeJson = (value) => {
  if (!value || value === "null" || value === "undefined") return null;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const getFirstStorageValue = (keys = []) => {
  for (const key of keys) {
    const value = localStorage.getItem(key);

    if (value && value !== "null" && value !== "undefined" && String(value).trim() !== "") {
      return value;
    }
  }

  return "";
};

const getCompanyName = () => {
  const directCompanyName = getFirstStorageValue([
    "companyname",
    "company_name",
    "companyName",
    "organization_name",
    "org_name",
    "property_name",
    "hotel_name",
  ]);

  if (directCompanyName) return directCompanyName;

  const companyRaw = getFirstStorageValue(["company", "companydetail", "company_details", "companyInfo"]);
  const company = getSafeJson(companyRaw);

  if (company) {
    return (
      company.company_name ||
      company.companyName ||
      company.name ||
      company.organization_name ||
      company.org_name ||
      company.property_name ||
      company.hotel_name ||
      company.display_name ||
      ""
    );
  }

  return companyRaw && companyRaw.length < 80 ? companyRaw : "";
};

const getInitials = (name = "") => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);

  if (!parts.length) return "NS";

  return parts.map((part) => part[0]).join("").toUpperCase();
};

const getBusinessDate = () => {
  const rawBusinessDate = getFirstStorageValue(["posbusiness_date", "business_date", "pos_business_date"]);

  if (rawBusinessDate && moment(rawBusinessDate).isValid()) {
    return moment(rawBusinessDate).format("Do MMM YYYY");
  }

  return moment().format("Do MMM YYYY");
};

const getLiveTime = () => moment().format("hh:mm A");

const Header = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = notifications.notifications;
  const datas = message.message;

  const [notification, setNotifications] = useState(false);
  const [flag, setflag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState(false);
  const [flagImage, setFlagImage] = useState(lnEnglish);
  const [currentTime, setCurrentTime] = useState(getLiveTime());

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const cdnUrl = process.env.REACT_APP_CDN_URL;
  const profilePic = localStorage.getItem("profilepic");
  const submitButtonRef = useRef(null);

  const companyName = useMemo(() => getCompanyName(), []);
  const companyInitials = useMemo(() => getInitials(companyName), [companyName]);
  const businessDate = useMemo(() => getBusinessDate(), [location.pathname]);

  const Credencial = localStorage.getItem("credencial");
  const Value = getSafeJson(Credencial);
  const UserName = Value?.email?.split("@")[0];
  const ProfileName = localStorage.getItem("username");
  const useremail = localStorage.getItem("useremail");
  const gender = localStorage.getItem("gender");

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrentTime(getLiveTime());
    }, 30000);

    return () => window.clearInterval(timer);
  }, []);

  const closeProfileModal = () => {
    if (submitButtonRef.current) {
      submitButtonRef.current.click();
    }

    const modalEl = document.getElementById("profile-menu");
    if (modalEl) {
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      modal.hide();
    }
  };

  const handleAppClick = (app) => {
    closeProfileModal();

    switch (app) {
      case "office":
        navigate("./employee-dashboard");
        break;
      case "hms":
        navigate("/hospitality");
        break;
      case "pos":
        alert("NetShine POS is available but not added to your plan. Please upgrade your plan.");
        break;
      default:
        break;
    }
  };

  const handleLogout = () => {
    closeProfileModal();
    localStorage.clear();
    sessionStorage.clear();
    navigate(baseUrl);
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const onMenuClik = () => {
    document.body.classList.toggle("slide-nav");
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setNotifications(false);
    setProfile(false);
    setflag(false);
  };

  const handleNotification = () => {
    setNotifications(!notification);
    setflag(false);
    setIsOpen(false);
    setProfile(false);
  };

  const handleProfile = () => {
    setProfile(!profile);
    setNotifications(false);
    setflag(false);
    setIsOpen(false);
  };

  const handleAccountClick = () => {
    closeProfileModal();
    setTimeout(() => {
      navigate("/hospitality/account-setting");
    }, 300);
  };

  const handleApiClick = () => {
    closeProfileModal();
    setTimeout(() => {
      navigate("/api-settings");
    }, 300);
  };

  const handleManageOrgClick = () => {
    closeProfileModal();
    setTimeout(() => {
      navigate("hospitality/manage-property");
    }, 300);
  };

  const { t } = { t: (key) => key };

  const avatarSrc =
    profilePic && profilePic.trim() !== "" && profilePic !== "null"
      ? `${String(cdnUrl || "").replace(/\/+$/, "")}/${String(profilePic).replace(/^\/+/, "")}`
      : gender === "male"
      ? Avatar_02
      : Avatar_01;

  return (
    <div className="header ns-app-header" style={{ right: "0px" }}>
      <style>{`
        .ns-app-header {
          height: 60px;
          min-height: 60px;
          background:
            radial-gradient(circle at 42% -60%, rgba(255, 255, 255, 0.16), transparent 28%),
            linear-gradient(135deg, #12359f 0%, #173fb5 58%, #0f2b88 100%) !important;
          border-bottom: 1px solid rgba(255, 255, 255, 0.12);
          box-shadow: 0 10px 28px rgba(15, 23, 42, 0.18);
          display: flex;
          align-items: center;
          z-index: 1100;
        }

        .ns-app-header .header-left {
          height: 60px;
          width: 180px;
          flex: 0 0 180px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(255, 255, 255, 0.08);
          padding: 0 18px;
        }

        .ns-app-header .logo {
          width: 100%;
          height: 60px;
          display: inline-flex !important;
          align-items: center;
          justify-content: flex-start;
        }

        .ns-app-header .logo2 {
          width: 100%;
          height: 60px;
          display: none !important;
          align-items: center;
          justify-content: center;
        }

        .mini-sidebar .ns-app-header .logo {
          display: none !important;
        }

        .mini-sidebar .ns-app-header .logo2 {
          display: inline-flex !important;
        }

        .ns-app-header .logo img {
          width: 140px;
          max-width: 100%;
          max-height: 34px;
          object-fit: contain;
          display: block;
        }

        .ns-app-header .logo2 img {
          width: 38px;
          height: 38px;
          max-height: 38px;
          object-fit: contain;
          display: block;
        }

        .ns-app-header .mobile_btn {
          display: none !important;
        }

        .ns-header-container {
          flex: 1 1 auto;
          min-width: 0;
          display: grid;
          grid-template-columns: minmax(220px, 1fr) auto;
          align-items: center;
          gap: 12px;
          padding: 0 10px 0 18px;
          height: 100%;
        }

        .ns-header-center {
          min-width: 0;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: clamp(16px, 6vw, 140px);
        }

        .ns-header-right {
          min-width: 0;
          height: 100%;
          display: inline-flex;
          align-items: center;
          justify-content: flex-end;
          gap: 8px;
        }

        .ns-header-company {
          min-width: 0;
          max-width: min(360px, 40vw);
          height: 42px;
          border-radius: 17px;
          padding: 0 15px 0 7px;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          color: #ffffff;
          background: rgba(255, 255, 255, 0.12);
          border: 1px solid rgba(255, 255, 255, 0.18);
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12), 0 10px 24px rgba(15, 23, 42, 0.14);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
        }

        .ns-header-company-mark {
          width: 32px;
          height: 32px;
          border-radius: 13px;
          background: #ffffff;
          color: #173fb5;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 0.72rem;
          font-weight: 950;
          flex: 0 0 auto;
          box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
        }

        .ns-header-company-copy {
          min-width: 0;
          display: flex;
          align-items: center;
        }

        .ns-header-company-copy strong {
          color: #ffffff;
          font-size: 0.86rem;
          line-height: 1;
          font-weight: 950;
          max-width: 285px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .ns-header-date-stack {
          height: 42px;
          display: inline-grid;
          grid-template-columns: auto auto;
          align-items: center;
          gap: 7px;
        }

        .ns-header-date-pill,
        .ns-header-time-pill {
          min-height: 42px;
          border-radius: 16px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0 15px;
          color: #ffffff;
          border: 1px solid rgba(255, 255, 255, 0.15);
          box-shadow: 0 10px 22px rgba(15, 23, 42, 0.16);
          white-space: nowrap;
        }

        .ns-header-date-pill {
          background: linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%);
        }

        .ns-header-time-pill {
          background: rgba(255, 255, 255, 0.10);
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.10);
        }

        .ns-header-date-pill strong,
        .ns-header-time-pill strong {
          font-size: 0.86rem;
          line-height: 1;
          font-weight: 950;
        }

        .ns-header-profile-section {
          height: 60px;
          display: inline-flex;
          align-items: center;
          margin-left: 2px;
        }

        .ns-header-profile-section .nav-item {
          list-style: none;
          margin: 0;
        }

        .ns-header-profile-toggle {
          min-height: 46px;
          border-radius: 18px;
          display: inline-flex !important;
          align-items: center;
          gap: 8px;
          padding: 4px 8px 4px 4px !important;
          background: rgba(255, 255, 255, 0.08);
          border: 1px solid rgba(255, 255, 255, 0.12);
          text-decoration: none !important;
          transition: transform 0.16s ease, background 0.16s ease;
        }

        .ns-header-profile-toggle:hover {
          transform: translateY(-1px);
          background: rgba(255, 255, 255, 0.13);
        }

        .ns-header-right .profile-section {
          flex: 0 0 auto;
        }


        .ns-header-profile-toggle.dropdown-toggle::after,
        .ns-header-profile-toggle::after {
          display: none !important;
          content: none !important;
          border: 0 !important;
          margin: 0 !important;
        }

        .ns-header-avatar-wrap {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .ns-header-avatar-wrap::after {
          content: "";
          position: absolute;
          right: 1px;
          bottom: 2px;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: #22c55e;
          border: 2px solid #173fb5;
        }

        .ns-header-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid rgba(255, 255, 255, 0.45);
          box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);
        }

        .ns-header-caret {
          color: #ffffff;
          font-size: 0.86rem;
          opacity: 0.9;
          padding-right: 2px;
        }

        @media (max-width: 1320px) {
          .ns-header-center {
            padding-left: clamp(8px, 3vw, 72px);
          }

          .ns-header-company {
            max-width: 300px;
          }

          .ns-header-company-copy strong {
            max-width: 220px;
          }
        }

        @media (max-width: 1180px) {
          .ns-app-header .header-left {
            width: 162px;
            flex-basis: 162px;
            padding: 0 14px;
          }

          .ns-app-header .logo img {
            width: 130px;
          }

          .ns-header-container {
            grid-template-columns: minmax(160px, 1fr) auto;
            padding-left: 10px;
          }

          .ns-header-company {
            max-width: 250px;
          }

          .ns-header-company-copy strong {
            max-width: 175px;
          }
        }

        @media (max-width: 991px) {
          .ns-header-container {
            display: flex;
            justify-content: flex-end;
          }

          .ns-header-center {
            display: none;
          }

          .ns-header-date-stack {
            grid-template-columns: auto;
          }

          .ns-header-time-pill {
            display: none;
          }
        }

        @media (max-width: 680px) {
          .ns-app-header .header-left {
            width: 148px;
            flex-basis: 148px;
          }

          .ns-header-date-pill {
            min-height: 34px;
            padding: 4px 9px;
          }

          .ns-header-date-pill strong {
            font-size: 0.75rem;
          }
        }

        @media (max-width: 520px) {
          .ns-header-date-stack {
            display: none;
          }

          .ns-app-header .header-left {
            width: 136px;
            flex-basis: 136px;
            padding: 0 10px;
          }

          .ns-app-header .logo img {
            width: 124px;
          }
        }
      `}</style>

      <div className="header-left">
        <Link to="/pos/" className="logo">
          <img src={headerlogo} width={150} height={50} alt="NetShine" />
        </Link>
        <Link to="/pos/" className="logo2">
          <img src={Applogo} width={40} height={40} alt="NetShine" />
        </Link>
      </div>

      <div className="ns-header-container">
        <div className="ns-header-center">
          {companyName ? (
            <div className="ns-header-company" title={companyName}>
              <span className="ns-header-company-mark">{companyInitials}</span>
              <span className="ns-header-company-copy">
                <strong>{companyName}</strong>
              </span>
            </div>
          ) : null}
        </div>

        <div className="ns-header-right">
          <div className="ns-header-date-stack" aria-label="Business date and current time">
            <div className="ns-header-date-pill" title="Business date">
              <strong>{businessDate}</strong>
            </div>

            <div className="ns-header-time-pill" title="Current time">
              <strong>{currentTime}</strong>
            </div>
          </div>

          <div className="profile-section ns-header-profile-section">
            <li className="nav-item dropdown has-arrow main-drop">
              <Link
                to="#"
                className="dropdown-toggle nav-link ns-header-profile-toggle"
                data-bs-toggle="modal"
                data-bs-target="#profile-menu"
                onClick={handleProfile}
                aria-label="Open profile menu"
              >
                <span className="user-img me-1">
                  <span className="ns-header-avatar-wrap">
                    <img
                      src={avatarSrc}
                      alt="User Avatar"
                      className="user-avatar ns-header-avatar"
                    />
                  </span>
                </span>
                <span className="ns-header-caret">
                  <i className="fa fa-chevron-down" />
                </span>
              </Link>
            </li>
          </div>
        </div>
      </div>

      <ProfileMenu
        profilePic={profilePic}
        gender={gender}
        ProfileName={ProfileName}
        useremail={useremail}
        flagImage={flagImage}
        handleLogout={handleLogout}
        handleAccountClick={handleAccountClick}
        handleApiClick={handleApiClick}
        handleManageOrgClick={handleManageOrgClick}
        handleAppClick={handleAppClick}
      />

      <div className="dropdown mobile-user-menu">
        <Link
          to="#"
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa fa-ellipsis-v" />
        </Link>
        <div className="dropdown-menu dropdown-menu-end dropdown-menu-right">
          <Link className="dropdown-item" to="/profile">
            My Profile
          </Link>
          <Link className="dropdown-item" to="hospitality/manage-property">
            Settings
          </Link>
          <Link className="dropdown-item" to="#" onClick={handleLogout}>
            Logout
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
